import script from "./NotificationList.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"NotificationList.vue"]])

export default __exports__